import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { tBillPayModel, BillPay_Patient_PackageModel } from 'src/app/models/tBillPayModel';
import { decimalplaceHandler } from 'src/app/services/Non-Master/decimalplaceHandler.service';
import { MissingInputPipe } from 'src/app/services/CommonService/ShowMissingInputMsg.pipe';
import { SystemDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { TranslateService } from '@ngx-translate/core';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';

@Component({
  selector: 'app-bill-payment-package-total-amount-input-value-dialog',
  templateUrl: './bill-payment-package-total-amount-input-value-dialog.component.html',
  styleUrls: ['./bill-payment-package-total-amount-input-value-dialog.component.css']
})
export class BillPaymentPackageTotalAmountInputValueDialogComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tBillPayService: tBillPayService,
    private formBuilder: FormBuilder,
    private decimalplaceHandler: decimalplaceHandler,
    private missingInputPipe: MissingInputPipe,
    private apiResultDialogService: ApiResultDialogService,
    private translate: TranslateService,
    private apiResultHandlerService: ApiResultHandlerService,
    private ngbModal: NgbModal,

  ) {
  }


  @Input() selectedBillPayModel: tBillPayModel;
  @Input() selectedBillPay_Patient_PackageModel: BillPay_Patient_PackageModel;
  @Input() orgArAmount: number;
  @Input() isChangePay?: boolean; //if the invoice/Bill use prepay from AR Settlement page , isChangePay = true



  editForm: FormGroup;
  submitted = false;


  private TAG = "BillPaymentPackageTotalAmountInputValueDialogComponent";

  // isloadingMsg = false;
  public loadingMsg: string = "";

  //
  public packageRemainingValue: number = 0;
  public packageOrgValue: number = 0;

  ngOnInit() {
    this.packageOrgValue = this.selectedBillPay_Patient_PackageModel.remainder;

    this.editForm = this.formBuilder.group({
      packageRemaining: [],
      packagePayValue: ['', [Validators.required]],
      afterPaymentRemainging: ['', [Validators.required]]
    });

    this.log.i(this.TAG, "selectedBillPayModel = " + this.selectedBillPayModel.bpArAmount + " , orgArAmount = " + this.orgArAmount);
    (<FormControl>this.editForm.controls['packageRemaining']).setValue(this.decimalplaceHandler.convertToValueStr(this.packageOrgValue, decimalplaceHandler.dpTotalAmt, decimalplaceHandler.round_TotalAmt));
    (<FormControl>this.editForm.controls['packagePayValue']).setValue(this.orgArAmount);


    this.CalRackageRemaining(this.packageOrgValue, this.orgArAmount);
  }

  cancel() {
    this.log.i(this.TAG, "do cancel");
    this.activeModal.close('Close click');
  }


  CalRackageRemaining(packageOrg: number, deductAmount: number) {
    (<FormControl>this.editForm.controls['afterPaymentRemainging']).setValue(this.displayTotalAmt(packageOrg - deductAmount));
  }

  get f() { return this.editForm.controls; }

  confirm() {
    // packageRemainingNotEnough

    this.submitted = true;
    // this.log.i(this.TAG, "onSubmit this.editForm.valid= " + this.findInvalidControls() );


    if (this.editForm.valid) {
      const messageCaptions = ["alert_pay_package_remainder_not_enough","Message_BillPay_Prescription_Price_NotMatch","ERORR_PAY_PRESCRIPTION_MISSING"];
      let i18n:any = {alert_pay_package_remainder_not_enough:""};

      this.translate.get(messageCaptions).subscribe(x=>i18n=x);

      // this.activeModal.dismiss();
      var inputValue = this.editForm.get('packagePayValue').value;
      this.log.i(this.TAG, "do confirm value =" + inputValue);

      if (inputValue > this.selectedBillPay_Patient_PackageModel.remainder) {
        this.log.w(this.TAG, "input value cannot > package remainder");

        this.loadingMsg = i18n.alert_pay_package_remainder_not_enough;

      } else
      {

        this.submitted = true;

        if (this.editForm.valid) {
          this.loadingMsg = "加載中請稍候...";

          this.selectedBillPayModel.bpArAmount = inputValue * -1;
          this.selectedBillPayModel.bpPackFaceAmt = inputValue * -1;

          this.log.i(this.TAG, "upload value = " + JSON.stringify(this.selectedBillPayModel));

          if(this.isChangePay){
            //when the bill has AR account with paying
            //TODO call changeMultiPaymentData api

            this.tBillPayService.changeMultiPaymentData([this.selectedBillPayModel])
            .subscribe((res)=>{
              console.log(res);
              this.activeModal.close(res);
            },err=>{
              this.ngbModal.dismissAll();
              if(err.error.custStatusCode){
                let msg = "";

                if(err.error.custStatusCode === "ERROR_BILL_IS_COMPLETED"){
                  this.translate.get(err.error.custStatusCode,{invoiceNumber: err.error.data.invoiceNumber}).subscribe(x=>msg = x);
                }else{
                  this.translate.get(err.error.custStatusCode).subscribe(x=>msg = x);
                }
                this.apiResultHandlerService.ErrHandlerWithMessage(msg);
              }else{
                this.apiResultHandlerService.ErrHandler();
              }
            });

          }else{
            //when the bill has no AR account with paying
            //TODO call postItemInfo api

            //update to server
            this.tBillPayService.addData(this.selectedBillPayModel)
            .subscribe(
              (data: any) => {

                this.log.i(this.TAG, "value = " + JSON.stringify(data));
                if (data.statusCode === StatusMessage.Status_BillPay_PackageRemainerNotEnough) {
                  this.loadingMsg = i18n.alert_pay_package_remainder_not_enough;
                  return;
                }

                if (data.statusCode != 200) {
                  let returnDisplayMsg = "";

                  if (
                    data.statusCode ===
                    StatusMessage.Status_BillPay_Prescription_Price_NotMatch
                  ) {
                    returnDisplayMsg =
                      i18n.Message_BillPay_Prescription_Price_NotMatch;
                  } else if (
                    data.custStatusCode &&
                    data.custStatusCode === "ERORR_PAY_PRESCRIPTION_MISSING"
                  ) {
                    returnDisplayMsg = i18n.ERORR_PAY_PRESCRIPTION_MISSING;
                  }

                  this.apiResultDialogService.openDialog(
                    MastersKeyStringValue.ACTION_MessageDialog,
                    AppSettings.Path_prescription,
                    MastersKeyStringValue.STATUS_FAIL,
                    returnDisplayMsg
                  );
                }




                this.activeModal.close(data);
              },
              err => {
                this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));

              });
            }



        }
      }
    }else{
      this.ShowMissingInputMsg();
    }





  }

  ShowMissingInputMsg() {
    const invalid = [];
    const controls = this.editForm.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
        this.log.i(this.TAG,'name = '+name);
      }
    }

    this.missingInputPipe.transform(invalid, SystemDefaultModel.Language_Chinese);
    // alert(invalid);

  }



  changePayAmount(payAmount: number) {
    this.CalRackageRemaining(this.packageOrgValue, payAmount);

  }


  displayTotalAmt(amt: number) {
    return this.decimalplaceHandler.convertToValueStr(amt, decimalplaceHandler.dpTotalAmt, decimalplaceHandler.round_TotalAmt);
  }

}
